import { URI_GUARD_REQUEST } from '@/config/config';

export default async ({ rootState }, { registerId }) => {
  try {
    const token = rootState['DATA-ACCESS'].tokenAuth;
    const url = new URL(`${URI_GUARD_REQUEST}serpro/details?registerId=${registerId}`);
    const opts = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'user-token': rootState['DATA-ACCESS'].userToken,
      },
    };
  
    const response = await fetch(url, opts);
    const jsonResult = await response.json();
  
    if (jsonResult.errors) {
      return Promise.reject(jsonResult.errors);
    }
  
    return jsonResult.register;
  } catch (error) {
    return Promise.reject(error);
  }
};
